import React from 'react';
import { Flex, IconButton, Tooltip } from '@chakra-ui/react';
import { EditIcon, DeleteIcon, LockIcon, ViewIcon, CheckIcon, CloseIcon } from '@chakra-ui/icons';

export const TableActionButton = ({ icon, label, onClick, variant = 'ghost', colorScheme = 'purple', isLoading = false, ...props }) => {
  return (
    <Tooltip label={label} placement="top">
      <IconButton
        icon={icon}
        aria-label={label}
        size="sm"
        variant={variant}
        colorScheme={colorScheme}
        onClick={onClick}
        isLoading={isLoading}
        {...props}
      />
    </Tooltip>
  );
};

export const TableActions = ({ children }) => {
  return (
    <Flex gap={2} alignItems="center">
      {children}
    </Flex>
  );
};

export { EditIcon, DeleteIcon, LockIcon, ViewIcon, CheckIcon, CloseIcon };
